import React, { useRef, useEffect, useState, useContext } from 'react';
import './vimeo.scss';
import Player from '@vimeo/player';
import { WidthContext } from '../../WidthContext';
import { lang } from '../lang';

function Vimeo() {
  const vimeoSRef = useRef();
  const vimeoLRef = useRef();
  const playerSRef = useRef();
  const playerLRef = useRef();
  const [currentVimeo, setCurrentVimeo] = useState(null);
  const { viewSize } = useContext(WidthContext);
  const { id, idmobile } = lang.vimeo;

  useEffect(() => {
    playerSRef.current = new Player(vimeoSRef.current, {
      id: idmobile,
      loop: true,
      controls: true,
      responsive: true,
      muted: true
    });
    playerLRef.current = new Player(vimeoLRef.current, {
      id: id,
      loop: true,
      controls: true,
      responsive: true,
      muted: true
    });
  }, [id, idmobile]);

  useEffect(() => {
    if (currentVimeo !== null) {
      currentVimeo.current.play().catch((error) => {
        console.log(error);
      });
    }
  }, [currentVimeo]);

  useEffect(() => {
    if (viewSize) {
      if (viewSize === 'large') {
        setCurrentVimeo(playerLRef);
      } else {
        setCurrentVimeo(playerSRef);
      }
    }
  }, [viewSize]);

  return (
    <div className="vimeo">
      <div ref={vimeoLRef} className="vimeo__player vimeo__player--l" />
      <div ref={vimeoSRef} className="vimeo__player vimeo__player--s" />
    </div>
  );
}

export default Vimeo;
